<template>
  <div>
    <additional-info-from-template
      v-if="showImportFromTemplate"
      :prop-item-data="propItemData"
      @add-from-form="showImportFromTemplate = false"
      @fecth-data="$emit('fecth-data')"
    />
    <additional-info-from-form
      v-else
      :current-index-item="currentIndexItem"
      :item="item"
      :prop-item-data="propItemData"
      @add-from-template="showImportFromTemplate = true"
      @clean-item="cleanItem()"
    />
    <div>
      <p>{{ $t('unit.additional_info') }}</p>
      <table v-if="propItemData.additional_info.length" class="table">
        <thead>
          <tr>
            <th class="text-center">
              {{ $tc('actions.name', 2) }}
            </th>
            <th class="text-center">
              {{ $t('unit.key') }}
            </th>
            <th class="text-center">
              {{ $t('unit.value') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(info, index) in propItemData.additional_info" :key="index">
            <td class="text-center">
              <b-button
                :id="`actions-${index}`"
                tabindex="0"
                variant="white"
                class="px-1 btn-y"
              >
                <feather-icon
                  data-cy="actions"
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </b-button>
              <b-popover
                :target="`actions-${index}`"
                triggers="focus"
                placement="bottom"
                custom-class="popover-p-0"
                variant="white"
              >
                <b-list-group class="m-0">
                  <b-list-group-item
                    @click="edit(info, index)"
                    class="border-0"
                    button
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">
                      {{  $t("actions.edit")}}
                    </span>
                  </b-list-group-item>
                </b-list-group>
                <b-list-group-item
                  @click="remove()"
                  class="border-0"
                  button
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">
                    {{$t("actions.delete")}}
                  </span>
                </b-list-group-item>
              </b-popover>
            </td>
            <td class="text-center">
              {{ info.key }}
            </td>
            <td class="text-center">
              {{ info.value }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-alert
        v-else
        show
        variant="warning"
        class="p-1"
      >
        {{ $t('unit.no_data') }}
      </b-alert>
    </div>
  </div>
</template>

<script>
import { computed,ref } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import AdditionalInfoFromForm from "./AdditionalInfoFromForm.vue";
import AdditionalInfoFromTemplate from "./AdditionalInfoFromTemplate.vue";

export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true,
    },
    propItemData: {
      type: Object,
      required: true,
    }
  },
  components: {
    AdditionalInfoFromForm,
    AdditionalInfoFromTemplate
  },
  setup (props) {
    //COMPOSABLES
    const { t } = useI18nUtils();


    //DATA
    const currentIndexItem = ref(0);

    const item = ref({
      id: null,
      key: null,
      value: null,
      exists: false
    });

    const showImportFromTemplate = ref(false);

    //COMPUTED

    //METHODS
    const cleanItem = () => {
      item.value = {
        id: null,
        key: null,
        value: null,
        exists: false
      }

      currentIndexItem.value = 0;
    }

    const edit = (infoSelected, index) => {
      item.value = { ...infoSelected };
      currentIndexItem.value = index;
    }

    const remove = (index) => {
      props.propItemData.additional_info.splice(index, 1);
    }

    const validateStep = () => {
      //console.log("Info Validate Step");

      return true;
      //console.log("Resultado de validación:", validation);

      // if (!validation) {
      //   console.warn("Algunos campos no pasaron la validación");
      //   console.log("Errores:", refFormObserver.value.errors);
      // }

    };

    return {
      currentIndexItem,
      item,
      showImportFromTemplate,

      cleanItem,
      edit,
      remove,
      validateStep
    }
  }
}
</script>
